module.exports = "/static/assets/533a93f0d8b2d5ee66a7afc2a54cefb7.png";